import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";
import * as ResponsiveImageHelper from "@/components/General/Image/helpers/responsiveImage.helpers";
import { ImageDefault } from "@/components/General/Image/image.default";
import { ImageLink } from "@/components/General/ImageLink/imageLink";

type Props = {
    className?: string;
};

export const Slide = ({ className }: Props) => {
    const { slides } = useBannerSliderContext();
    const { index } = useMapped();

    const slide = slides.at(index);

    if (!slide) {
        return null;
    }

    const imageProps = ResponsiveImageHelper.toImageProps({
        image: slide.responsiveImage,
        mobileImage: slide.responsiveImageMobile
    });

    const { slider_slides_slide } = bannerSlider();

    return (
        <>
            {!slide.href && (
                <ImageDefault
                    {...imageProps}
                    trackingProps={slide.trackingProps}
                    intersectionOptions={{
                        threshold: 0.4
                    }}
                    className={cn(
                        slider_slides_slide(),
                        imageProps.className,
                        className
                    )}
                />
            )}
            {slide.href && (
                <ImageLink
                    {...imageProps}
                    href={slide.href}
                    advisorId={undefined}
                    advisorType={undefined}
                    advisorMode={undefined}
                    openInNewTab={slide.openInNewTab}
                    trackingProps={slide.trackingProps}
                    intersectionOptions={{
                        threshold: 0.4
                    }}
                    className={cn(
                        slider_slides_slide(),
                        imageProps.className,
                        className
                    )}
                />
            )}
        </>
    );
};
